import { validarPermisoComponente } from '../../../plugins/acl';

export const IsBlockDesignFormMixin = {
    computed: {

        userHasPermissionToChangePublishedState() {
            return validarPermisoComponente('cambiar-estado-publicación-etiquetas-diseñador');
        },

        hasBlockFields() {
            if (this.selectedLayout.id && this.userHasPermissionToChangePublishedState && !!this.selectedLayout.is_published) {
                return true
            }
            if (this.selectedLayout.id && !this.userHasPermissionToChangePublishedState && !!this.selectedLayout.is_published) {
                return true
            }
            if (!this.userHasPermissionToChangePublishedState && !!this.selectedLayout.is_published && !this.selectedLayout.id) {
                return true
            }
            if (this.userHasPermissionToChangePublishedState && this.selectedLayout.id) {
                return false
            }
            
            return false
        }
    }
}